import { GHLLanguageKeys as e } from "./ghl-ui.es268.js";
const r = {
  name: e.spanish,
  global: {
    undo: "Deshacer",
    redo: "Rehacer",
    confirm: "Confirmar",
    clear: "Limpiar",
    more: "más",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor Seleccionar",
    loading: "Cargando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Limpiar",
    now: "Ahora",
    confirm: "Confirmar",
    selectTime: "Seleccionar Hora",
    selectDate: "Seleccionar Fecha",
    datePlaceholder: "Seleccionar Fecha",
    datetimePlaceholder: "Seleccionar Fecha y Hora",
    monthPlaceholder: "Seleccionar Mes",
    yearPlaceholder: "Seleccionar Año",
    quarterPlaceholder: "Seleccionar Trimestre",
    startDatePlaceholder: "Fecha de Inicio",
    endDatePlaceholder: "Fecha Final",
    startDatetimePlaceholder: "Fecha y Hora de Inicio",
    endDatetimePlaceholder: "Fecha Hora Final",
    monthBeforeYear: !0,
    startMonthPlaceholder: "Mes de Inicio",
    endMonthPlaceholder: "Mes final",
    firstDayOfWeek: 6,
    today: "Hoy"
  },
  DataTable: {
    checkTableAll: "Seleccionar todo en la tabla",
    uncheckTableAll: "Deseleccionar todo en la tabla",
    confirm: "Confirmar",
    clear: "Limpiar",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Origen",
    targetTitle: "Objetivo"
  },
  Transfer: {
    selectAll: "Seleccionar Todos",
    unselectAll: "Deseleccionar todos",
    clearAll: "Limpiar"
  },
  Empty: {
    description: "Sin datos"
  },
  Select: {
    placeholder: "Por favor selecciona"
  },
  TimePicker: {
    placeholder: "Seleccionar hora",
    positiveText: "De acuerdo",
    negativeText: "Cancelar",
    now: "Ahora"
  },
  Pagination: {
    goto: "Ir a",
    selectionSuffix: "Pagina",
    next: "Siguiente",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Agregar"
  },
  Log: {
    loading: "Cargando"
  },
  Input: {
    placeholder: "Por favor, entrada"
  },
  InputNumber: {
    placeholder: "Por favor, entrada"
  },
  DynamicInput: {
    create: "Crear"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpiar todas las variables",
    clearSearch: "Limpiar búsqueda",
    filterCompName: "Filtrar nombre del componente",
    filterVarName: "Filtrar variable de nombre",
    import: "Importar",
    export: "Exportar",
    restore: "restablecer a predeterminado"
  },
  Image: {
    tipPrevious: "Foto anterior (←)",
    tipNext: "Siguiente foto (→)",
    tipCounterclockwise: "Sentido contrario a las agujas del reloj",
    tipClockwise: "Sentido de las agujas del reloj",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Cerrar (Esc)",
    tipOriginalSize: "Zoom al tamaño original"
  },
  SortFilter: {
    heading: "Ordenar y filtrar",
    sortHeading: "Ordenar por",
    newestFirst: "Más recientes primero",
    oldestFirst: "Más antiguos primero",
    ascending: "Ascendente",
    descending: "Descendente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpiar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "No se encontraron resultados coincidentes"
  }
};
export {
  r as es
};
